// extracted by mini-css-extract-plugin
export default {"wrapper":"ListOfComplaints_wrapper__zP-8Y"};